<template lang="pug">
	modal(:max-width="1200")
		.card.text-left
			.card-header.bg-info
				span.fa.fa-calendar.mr-2
				| Inserciones
				button.close(@click="cerrar") &times;
			.contenedor
				.listadoInserciones
					table.table.table-hover.m-0.bordes
						thead
							tr.bg-dark.text-white
								th.text-right.p-1 ID
								th.text-right.p-1 Ref. Externa
								th.text-right.p-1 Descripción
								th.text-right.p-1 Ins
								th.text-right.p-1 Importe
								th.text-right.p-1 Dto
								th.text-right.p-1 Recargo
								th.text-right.p-1 Programa
								th.text-right.p-1 Contenido
								th.text-right.p-1 H. inicio
								th.text-right.p-1 H. fin
								th.text-right.p-1 Fijar
								th.text-right.p-1 Importe final
								th.text-center.p-1
									span.fa.fa-eye
						tbody
							tr(
								v-for="(insercion, i) in inserciones"
								@click="seleccionarInsercion(insercion.InsercionID)"
								:class="insercionSeleccionada === insercion.InsercionID ? 'bg-warning' : ''"
								:key="insercion.InsercionID"
							)
								td.p-1.text-center(style="cursor:pointer;", @click="seleccionarOriginal(insercion)")
									span.mr-2(v-if="!/^I/.test(insercion.InsercionID)") {{ insercion.InsercionID }}
									span.fa.fa-search.text-danger(title="Asociar original")
								td.p-1.text-right
									input.inline(v-model="inserciones[i].RefExterna")
								td.p-1.text-right(style="max-width:150px;", :title="insercion.FicheroID + ' - ' + insercion.Descripcion")
									.titulo {{insercion.FicheroID}} - {{ insercion.Descripcion }}
								td.p-1.text-right
									input.inline(v-model.number="inserciones[i].Inserciones", size="2", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
								td.p-1.text-right
									input.inline(v-model.number="inserciones[i].Importe", size="2", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
								td.p-1.text-right
									input.inline(v-model.number="inserciones[i].Descuento", size="2", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
								td.p-1.text-right
									input.inline(v-model.number="inserciones[i].Recargo", size="2", @focus="seleccionarTodo($event)", @keyup="calculaImportes")
								td.p-1.text-right {{ insercion.ProgramaNombre }}
								td.p-1.text-right {{ insercion.ContenidoNombre }}
								td.p-1.text-right {{ insercion.HoraInicio }}
								td.p-1.text-right {{ insercion.HoraFin }}
								td.p-1.text-right {{ insercion.Fijar }}
								td.p-1.text-right.bg-danger.text-white {{ insercion.ImporteFinal | currency('') }} €
								td.p-1.text-center(style="cursor:pointer;", @click="resumen = insercion")
									span.fa.fa-eye

				.menu
					.icono(@click="nuevaInsercion")
						span.fa.fa-plus
					.icono(:class="!insercionSeleccionada ? 'disabled' : ''", @click="eliminarRadiacion")
						span.fa.fa-trash
					.icono(:class="!insercionSeleccionada ? 'disabled' : ''", @click="colocar")
						span.fa.fa-cubes
			.card-footer
				button.btn.btn-sm.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
			
			Colocacion(:EmisoraID="linea.EmisoraID", v-if="insercionSeleccionada && colocando", @cerrar="colocando = false", @colocacion="setColocacion($event)")
			ModalSeleccionOriginal(v-if="seleccionOriginal", :solo="true", :ClienteID="contrato.ClienteID", @cerrar="seleccionOriginal = null", @seleccionar="onSeleccionarOriginal($event)")
			ResumenBloques(v-if="resumen", :insercion="resumen", :bloques="bloques", @cerrar="resumen = null")
</template>

<script>
import ModalSeleccionOriginal from '../utilidades/modalSeleccionOriginal.component.vue'
import ResumenBloques from './resumen-bloques.component'
import Colocacion from '../colocacion/colocacion.vue'
import Servicios from '../../../servicios'
export default {
	props: ['linea', 'dia', 'contrato', 'bloques'],
	components: {
		Colocacion,
		ModalSeleccionOriginal,
		ResumenBloques
	},
	data () {
		return {
			insercionSeleccionada: null,
			inserciones: [],
			colocando: false,
			seleccionOriginal: null,
			resumen: null
		}
	},
	created () {
		this.inserciones = [].concat(this.linea.inserciones).filter(i => i.Dia === this.dia && !i.Anulada).map(i => JSON.parse(JSON.stringify(i)))
	},
	methods: {
		seleccionarInsercion (InsercionID) {
			this.insercionSeleccionada = InsercionID
		},
		seleccionarOriginal (insercion) {
			this.seleccionOriginal = insercion
		},
		onSeleccionarOriginal ($event) {
			this.seleccionOriginal.FicheroID = $event[0].FicheroID
			this.seleccionOriginal.Descripcion = $event[0].Descripcion
		},
		nuevaInsercion () {
			const ins = Servicios.NuevaInsercion(this.dia)
			this.inserciones.push(ins)
		},
		eliminarRadiacion () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar insercion',
				mensaje: '¿Quieres eliminar esta(s) insercion(es)?',
				callback: acepta => {
					if (acepta) {
						this.inserciones = this.inserciones.filter(r => r.InsercionID !== this.insercionSeleccionada)
						this.insercionSeleccionada = null
					}
				}
			})
		},
		colocar () {
			if (!this.insercionSeleccionada) {
				return
			}

			this.colocando = true
		},
		setColocacion (datos) {
			this.inserciones = this.inserciones.map(r => {
				if (r.InsercionID === this.insercionSeleccionada) {
					r = {...r, ...datos}
				}
				return r
			})
		},
		guardar () {
			// this.linea.inserciones = this.inserciones.filter(i => (i.FicheroID))
			this.$emit('guardar', this.inserciones)
		},
		cerrar () {
			this.$emit('cerrar')
		},
		calculaImportes () {
			for (let i = 0; i < this.inserciones.length; i++) {
				const l = this.inserciones[i]
				let importe = (isNaN(l.Importe)) ? 0 : l.Importe
				if (!isNaN(l.Descuento)) {
					importe = importe - (importe * l.Descuento / 100)
				}

				if (!isNaN(l.Recargo)) {
					importe = importe + l.Recargo
				}

				this.inserciones[i].ImporteFinal = importe
			}
		},
		seleccionarTodo (e) {
			e.target.setSelectionRange(0, e.target.value.length)
		}
	}
}
</script>

<style scoped>
.contenedor {
	display: flex;
	position: relative;
	width: 100%;
	flex-direction: row;
	align-content: stretch;
}

.listadoInserciones {
	flex-grow: 3;
	background-color: white;
}

.menu {
	display: flex;
	flex-direction: column;
	flex-grow: 0;
	flex-shrink: 0;
	/* width: 50px; */
	flex-basis: 50px;
	background-color: #f0f0f0;
	border-left: 1px solid #e0e0e0;
	align-items: stretch;
	align-content: stretch;
	padding: 0;
}

.menu > .icono {
	cursor: pointer;
	text-align: center;
	position: relative;
	display: block;
	padding: 5px;
	font-size: 2em;
	color: #222222;
	opacity: 0.7;
}

.menu > .icono:hover {
	background-color: rgba(255, 255, 255, 0.7);
	opacity: 1;
}

.icono.disabled {
	opacity: 0.1;
}

.icono.disabled:hover {
	background-color: inherit;
	opacity: 0.1;
}

table.bordes > tbody > tr > td {
	border-right: 1px solid #e0e0e0;
	user-select: none;
}

table.bordes > tbody > tr:last-of-type > td {
	border-right: 1px solid #e0e0e0;
	border-bottom: 1px solid #e0e0e0;
}

table.bordes > tbody > tr > td:last-of-type {
	border-right: none;
}

.titulo {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

input.inline {
	border: 0;
	margin: 0;
	padding: 1px;
	text-align: right;
	background-color: rgba(0,0,0,0);
	width: 100%;
	display: block;
	position: relative;
	cursor: pointer;
}

input.inline:focus {
	border: none;
	outline: none;
}

</style>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/detalles-dia/detalles-dia.vue